import React from 'react';
import SelectField from 'components/input/SelectField/SelectField';

const TestBookingFilter = <SelectField
    choices={ [
        {
            id: '0',
            name: 'filters.components.testBooking.choices.real',
        },
        {
            id: '1',
            name: 'filters.components.testBooking.choices.test',
        },
    ] }
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='filters.components.testBooking.label'
    source='is_test_order'
/>;

export default TestBookingFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/TestBookingFilter.js